import { render, staticRenderFns } from "./list.vue?vue&type=template&id=96626e4e&scoped=true"
import script from "./list.vue?vue&type=script&lang=ts"
export * from "./list.vue?vue&type=script&lang=ts"
import style0 from "./list.vue?vue&type=style&index=0&id=96626e4e&lang=scss&scoped=true"
import style1 from "./list.vue?vue&type=style&index=1&id=96626e4e&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96626e4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96626e4e')) {
      api.createRecord('96626e4e', component.options)
    } else {
      api.reload('96626e4e', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=96626e4e&scoped=true", function () {
      api.rerender('96626e4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/list.vue"
export default component.exports